import { ModalBody, ModalFoot, Text } from '@dixa/lib-shared-habla';

import { WebformEndpoint, webformEndpointsApi } from 'apis/webformEndpoints';
import { NotificationType, useNotifications } from 'hooks/useNotifications';

type Props = {
  endpoint: WebformEndpoint;
  hide: () => void;
};

export function CanDeleteFormEndpoint({ endpoint, hide }: Props): JSX.Element {
  const notify = useNotifications();
  const [deleteEndpoint, { isLoading: isDeleting }] =
    webformEndpointsApi.useDeleteWebformEndpointMutation();

  const handleDeleteEndpoint = async () => {
    try {
      await deleteEndpoint({ webformId: endpoint.id });

      notify(
        {
          title: 'Success',
          text: `"${endpoint.description}" has been deleted.`,
          icon: 'i-done',
          time: 5000,
        },
        NotificationType.Success,
      );
      hide();
    } catch (error) {
      notify(
        { title: `Error while deleting "${endpoint.description}"` },
        NotificationType.Error,
      );
    }
  };

  return (
    <>
      <ModalBody>
        <Text.Paragraph>
          Are you sure you want to delete this form?
        </Text.Paragraph>
      </ModalBody>

      <ModalFoot
        confirmOnClick={handleDeleteEndpoint}
        cancelOnClick={hide}
        cancelProps={{
          disabled: isDeleting,
        }}
        confirmName="Delete"
        confirmProps={{
          isLoading: isDeleting,
          loadingIndicator: 'Deleting...',
          disabled: isDeleting,
          variant: 'danger',
        }}
      />
    </>
  );
}
